<div class="skeleton-container">
  @if (type === 'chart') {
    <div class="skeleton-chart" [style.height.px]="height">
      <div class="skeleton-shimmer"></div>
    </div>
  }

  @if (type === 'table') {
    <div class="skeleton-table">
      @for (row of getRows(); track row) {
        <div class="skeleton-table-row">
          @for (col of getColumns(); track col) {
            <div class="skeleton-table-cell">
              <div class="skeleton-shimmer"></div>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (type === 'text') {
    <div class="skeleton-text" [style.width.px]="width">
      <div class="skeleton-shimmer"></div>
    </div>
  }

  @if (type === 'card') {
    <div class="skeleton-card" [style.height.px]="height">
      <div class="skeleton-shimmer"></div>
    </div>
  }

  @if (type === 'sidebar') {
    <div class="skeleton-sidebar">
      <div class="skeleton-sidebar-header">
        <div class="skeleton-shimmer"></div>
      </div>

      @for (item of getRows(); track item) {
        <div class="skeleton-sidebar-item">
          <div class="skeleton-sidebar-color-bar"></div>
          <div class="skeleton-sidebar-content">
            <div class="skeleton-sidebar-title">
              <div class="skeleton-shimmer"></div>
            </div>
            <div class="skeleton-sidebar-subtitle">
              <div class="skeleton-shimmer"></div>
            </div>
          </div>
          <div class="skeleton-sidebar-action">
            <div class="skeleton-shimmer"></div>
          </div>
        </div>
      }

      <div class="skeleton-sidebar-total">
        <div class="skeleton-shimmer"></div>
      </div>
    </div>
  }

  @if (type === 'map') {
    <div class="skeleton-map">
      <div class="skeleton-shimmer"></div>
    </div>
  }
</div>
